import { render, staticRenderFns } from "./CaptureCard.vue?vue&type=template&id=61d55507&scoped=true"
import script from "./CaptureCard.vue?vue&type=script&lang=js"
export * from "./CaptureCard.vue?vue&type=script&lang=js"
import style0 from "./CaptureCard.vue?vue&type=style&index=0&id=61d55507&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d55507",
  null
  
)

export default component.exports